<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">PWmat</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">PWmat {{ $t("pwmat.title") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            {{ $t("pwmat.intrP1") }}
          </p>
          <p class="pwmat-introduce-content-info-text">
            {{ $t("pwmat.intrP2") }}
          </p>
          <p class="pwmat-introduce-content-info-text">
            {{ $t("pwmat.intrP2") }}
          </p>
        </div>

        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">{{ $t("pwmat.feature") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_4.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun01name") }}</div>
              <div class="pwmat-introduce-function-desc">
                LDA、GGA、meta-GGA
              </div>
              <div class="pwmat-introduce-function-desc">{{ $t("pwmat.fun01desc1") }} HSE</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_2.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">
                {{ $t("pwmat.fun02name") }}
              </div>
              <div class="pwmat-introduce-function-desc">{{ $t("pwmat.fun02desc1") }}</div>
              <div class="pwmat-introduce-function-desc">{{ $t("pwmat.fun02desc2") }} MD、NEB</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_3.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun03name") }}</div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun03desc1") }}
              </div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun03desc2") }}（SOC）
              </div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_1.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun04name") }}</div>
              <div class="pwmat-introduce-function-desc">{{ $t("pwmat.fun04desc1") }}</div>
              <div class="pwmat-introduce-function-desc">{{ $t("pwmat.fun04desc2") }}</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_5.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun05name") }}</div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun05desc1") }}
              </div>
              <div class="pwmat-introduce-function-desc">{{ $t("pwmat.fun05desc2") }}</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_6.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun06name") }}</div>
              <div class="pwmat-introduce-function-desc">wannier {{ $t("pwmat.fun06desc1") }}</div>
              <div class="pwmat-introduce-function-desc">GW {{ $t("pwmat.fun06desc1") }}</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_7.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">rt-TDDFT</div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun07desc1") }}
              </div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun07desc2") }}
              </div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_8.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun08name") }}</div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun08desc1") }}
              </div>
              <div class="pwmat-introduce-function-desc">
                defect state、level
              </div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_9.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">{{ $t("pwmat.fun09name") }}</div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun09desc1") }}
              </div>
              <div class="pwmat-introduce-function-desc">
                {{ $t("pwmat.fun09desc2") }}
              </div>
            </div>
          </div>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">PWmat {{ $t("pwmat.app") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            {{ $t("pwmat.appP1") }}
          </p>
        </div>
        <div class="pwmat-inroduce-application">
          <div class="pwmat-inroduce-application-group-1">
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR1C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR2C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR3C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR4C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR5C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR6C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR7C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR8C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR9C1") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR10C1") }}</p>
          </div>

          <div class="pwmat-inroduce-application-group-2">
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR1C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR2C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR3C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR4C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR5C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR6C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR7C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR8C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR9C2") }}</p>
            <p class="pwmat-inroduce-application-text">{{ $t("pwmat.appR10C2") }}</p>
          </div>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("pwmat.test") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/pwmat-resource/pwmatSpeedTest.pdf'"
          >
          {{ $t("pwmat.testSpeed") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/test-document/6'"
          >
          {{ $t("pwmat.testAccuracy") }}
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("pwmat.allinone") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mstation-introduce'"
          >
            Mstation
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mcluster-introduce'"
          >
            Mcluster
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mcloud-introduce'"
          >
            Mcloud
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("pwmat.try") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='http://longxun2015.mikecrm.com/y72WBOU'"
          >
          {{ $t("pwmat.tryApply") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mcloud-introduce'"
          >
          {{ $t("pwmat.tryMcloud") }}
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("pwmat.tutor") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toQuikStart"
          >
          {{ $t("pwmat.tutorStart") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toTutorials"
          >
          {{ $t("pwmat.tutors") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toCase"
          >
          {{ $t("pwmat.tutorCase") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toTrain"
          >
          {{ $t("pwmat.tutorVideo") }}
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("pwmat.link") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toMSTATIONDownload"
          >
            PWmat {{ $t("pwmat.download") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toModuleDownload"
          >
            Module {{ $t("pwmat.download") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toPotentialDownload"
          >
            {{ $t("pwmat.potentialDownload") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toManual"
          >
          {{ $t("pwmat.enDownload") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="tocnManual"
          >
          {{ $t("pwmat.zhDownload") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/paper'"
          >
          {{ $t("pwmat.paper") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toQuikStart() {
      this.$router.push({ name: "QuickStartTutorial" });
    },
    toTutorials() {
      this.$router.push({ name: "Tutorials" });
    },
    toCase() {
      this.$router.push({ name: "Case" });
    },
    toTrain() {
      this.$router.push({ name: "Train" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    tocnManual() {
      window.open(this.PWMAT_RESOURCE + "Manual_cn.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
    toProchureNewFunctions() {
      window.open(this.PWMAT_RESOURCE + "PWmat_2019_new_functions.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-introduce-content-info-text2 {
  font-size: 20px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.pwmat-introduce-function {
  display: inline-block;
  padding-left: 80px;
  margin-bottom: 50px;
  width: 346px;
}
.pwmat-introduce-function-img {
  display: inline-block;
  vertical-align: top;
}
.pwmat-introduce-function-text {
  display: inline-block;
  vertical-align: top;
  margin-left: 23px;
}
.pwmat-introduce-function-name {
  font-size: 18px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 8px;
  margin-top: -6px;
}
.pwmat-introduce-function-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 20px;
}
.pwmat-inroduce-application {
  background: rgba(73, 145, 201, 0.1);
  padding: 24px 99px 27px 99px;
  margin-bottom: 50px;
}
.pwmat-inroduce-application-group-1 {
  width: 539px;
  display: inline-block;
}
.pwmat-inroduce-application-group-2 {
  width: 299px;
  display: inline-block;
}
.pwmat-inroduce-application-text {
  font-size: 16px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 38px;
  margin-bottom: 0;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
